import { useMemo } from "react";
import style from "./input_checkbox.module.css";

export default function InputCheckbox({
  color = "blue",
  parentClassName = "",
  text = "",
  onClick = () => {},
  onChange = () => {},
  name = "inputCheckbox",
  defaultValue = "checked" || "",
  isUncheckAllowed = true,
  usedChecked = false,
  readonly = false,
  value = "",
  disabled = "disabled" || "",
  checked = "checked" || "",
  dataTestId = "",
  error,
}) {
  const isChecked = !isUncheckAllowed ? { checked: true } : {};
  const getColor = (color) => {
    switch (color) {
      case "blue":
        return style.blue;
      case "outline":
        return style.outline;
    }
  };
  const checkboxColor = getColor(color);

  const checkboxError = useMemo(() => {
    return error ? style.checkbox_error : "";
  }, [error]);

  return (
    <div
      className={`${checkboxColor} ${style.checkbox_wrapper} ${parentClassName} ${checkboxError}`}
    >
      <label>
        {!isUncheckAllowed && (
          <input
            name={name}
            type="checkbox"
            {...isChecked}
            readOnly={true}
            dataTestId={dataTestId}
          />
        )}
        {isUncheckAllowed && !usedChecked && (
          <input
            name={name}
            type="checkbox"
            value={value}
            onClick={onClick}
            onChange={onChange}
            defaultChecked={defaultValue}
            dataTestId={dataTestId}
          />
        )}
        {usedChecked && (
          <input
            name={name}
            type="checkbox"
            onClick={onClick}
            onChange={onChange}
            value={value}
            readOnly={readonly}
            checked={checked}
            disabled={disabled}
            dataTestId={dataTestId}
          />
        )}
        <span>{text}</span>
      </label>
    </div>
  );
}
